<template>
  <input type="text" class="input-value" :value="action.value" @change="store.commit(`${storeId}.value`, $event.target.value)" placeholder="Value" />
</template>

<script>
export default {
  emits: ['changeValue'],
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    event() {
      return this.config?.event ?? null
    },
    action() {
      return this.config?.action || {}
    },
    more() {
      return this.config?.more || {}
    }
  },
  methods: {
    //
  },
  props: {
    config: Object
  }
}
</script>
